export default "__VITE_ASSET__BMRZUmx3__"